export default {
  version: '0.0.0',
};



// WEBPACK FOOTER //
// ./src/version.js